import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { Layout } from './components/layout/Layout';
const Home = lazy(() => import('./pages/Home').then(m => ({
  default: m.Home
})));
const About = lazy(() => import('./pages/About').then(m => ({
  default: m.About
})));
const Services = lazy(() => import('./pages/Services').then(m => ({
  default: m.Services
})));
const Workshops = lazy(() => import('./pages/Workshops').then(m => ({
  default: m.Workshops
})));
const Talks = lazy(() => import('./pages/Talks').then(m => ({
  default: m.Talks
})));
const Courses = lazy(() => import('./pages/Courses').then(m => ({
  default: m.Courses
})));
const Events = lazy(() => import('./pages/Events').then(m => ({
  default: m.Events
})));
const Contact = lazy(() => import('./pages/Contact').then(m => ({
  default: m.Contact
})));
const Privacy = lazy(() => import('./pages/Privacy').then(m => ({
  default: m.Privacy
})));
const Terms = lazy(() => import('./pages/Terms').then(m => ({
  default: m.Terms
})));
const Writing = lazy(() => import('./pages/Writing').then(m => ({
  default: m.Writing
})));

// Challenge landing pages
const NewToLeadership = lazy(() => import('./pages/services/NewToLeadership').then(m => ({
  default: m.NewToLeadership
})));
const ConflictAndConversations = lazy(() => import('./pages/services/ConflictAndConversations').then(m => ({
  default: m.ConflictAndConversations
})));
const MeetingsAndFacilitation = lazy(() => import('./pages/services/MeetingsAndFacilitation').then(m => ({
  default: m.MeetingsAndFacilitation
})));
const LeadingInComplexity = lazy(() => import('./pages/services/LeadingInComplexity').then(m => ({
  default: m.LeadingInComplexity
})));

// How I work
const Coaching = lazy(() => import('./pages/services/Coaching').then(m => ({
  default: m.Coaching
})));
const EmbeddedPartner = lazy(() => import('./pages/services/EmbeddedPartner').then(m => ({
  default: m.EmbeddedPartner
})));

// Course detail pages
const ConflictCoaching = lazy(() => import('./pages/courses/ConflictCoaching').then(m => ({
  default: m.ConflictCoaching
})));
const FirstTimeManager = lazy(() => import('./pages/courses/FirstTimeManager').then(m => ({
  default: m.FirstTimeManager
})));
const BetterOnlineMeetings = lazy(() => import('./pages/courses/BetterOnlineMeetings').then(m => ({
  default: m.BetterOnlineMeetings
})));
const BetterOnlineWorkshops = lazy(() => import('./pages/courses/BetterOnlineWorkshops').then(m => ({
  default: m.BetterOnlineWorkshops
})));
const ModernProductManagement = lazy(() => import('./pages/courses/ModernProductManagement').then(m => ({
  default: m.ModernProductManagement
})));
const ArtOfFacilitation = lazy(() => import('./pages/courses/ArtOfFacilitation').then(m => ({
  default: m.ArtOfFacilitation
})));

// Open course sign-up pages
const ConflictCourseSignup = lazy(() => import('./pages/courses/ConflictCourseSignup').then(m => ({
  default: m.ConflictCourseSignup
})));

// Workshop detail pages
const StrategyWorkshop = lazy(() => import('./pages/workshops/StrategyWorkshop').then(m => ({
  default: m.StrategyWorkshop
})));
const FeedbackWorkshop = lazy(() => import('./pages/workshops/FeedbackWorkshop').then(m => ({
  default: m.FeedbackWorkshop
})));
const CoachingSkillsForManagers = lazy(() => import('./pages/workshops/CoachingSkillsForManagers').then(m => ({
  default: m.CoachingSkillsForManagers
})));

// Writing series pages
const OnFeedback = lazy(() => import('./pages/writing/OnFeedback').then(m => ({
  default: m.OnFeedback
})));
const OnConflict = lazy(() => import('./pages/writing/OnConflict').then(m => ({
  default: m.OnConflict
})));
const LessonsOfLeadership = lazy(() => import('./pages/writing/LessonsOfLeadership').then(m => ({
  default: m.LessonsOfLeadership
})));
const LessonsOfAgility = lazy(() => import('./pages/writing/LessonsOfAgility').then(m => ({
  default: m.LessonsOfAgility
})));
const LessonsOfStrategy = lazy(() => import('./pages/writing/LessonsOfStrategy').then(m => ({
  default: m.LessonsOfStrategy
})));
const OnTeams = lazy(() => import('./pages/writing/OnTeams').then(m => ({
  default: m.OnTeams
})));
function LoadingFallback() {
  return <div className="min-h-[60vh] flex items-center justify-center" data-id="element-0" data-mp="h59jeqo8l47u">
      <div className="w-8 h-8 border-3 border-teal border-t-transparent rounded-full animate-spin" data-id="element-1" data-mp="c9kbo022ch0g" />
    </div>;
}
function AnimatedRoutes() {
  return <Suspense fallback={<LoadingFallback data-id="element-3" data-mp="14wnbqwme0zst" />} data-id="element-2" data-mp="14x6idh6l81rj">
      <Routes data-id="element-4" data-mp="14xg956zgicya">
        <Route path="/" element={<Home data-id="element-6" data-mp="zxttkqw5okmb" />} data-id="element-5" data-mp="14xq2n4jpn28q" />
        <Route path="/about" element={<About data-id="element-8" data-mp="zwiqktajbgw9" />} data-id="element-7" data-mp="zxamk581ngn2" />
        <Route path="/events" element={<Events data-id="element-10" data-mp="vw8jteex4mgc" />} data-id="element-9" data-mp="zw0p9i90mchh" />

        {/* Writing */}
        <Route path="/writing" element={<Writing data-id="element-12" data-mp="vybdq9j6yzqc" />} data-id="element-11" data-mp="vvgqybcph2tr" />
        <Route path="/writing/on-feedback" element={<OnFeedback data-id="element-14" data-mp="3koubf1ihda52" />} data-id="element-13" data-mp="3knt14z9agroe" />
        <Route path="/writing/on-conflict" element={<OnConflict data-id="element-16" data-mp="3gly07vv9sgb5" />} data-id="element-15" data-mp="3klycpayt6hfk" />
        <Route path="/writing/lessons-of-leadership" element={<LessonsOfLeadership data-id="element-18" data-mp="1w4ezeced2rhs" />} data-id="element-17" data-mp="3gloam9e50b5z" />
        <Route path="/writing/lessons-of-agility" element={<LessonsOfAgility data-id="element-20" data-mp="1w2lv33r80jcy" />} data-id="element-19" data-mp="1w5gcsniunq2o" />
        <Route path="/writing/lessons-of-strategy" element={<LessonsOfStrategy data-id="element-22" data-mp="203xn1fxkhgob" />} data-id="element-21" data-mp="205ieuxshylih" />
        <Route path="/writing/on-teams" element={<OnTeams data-id="element-24" data-mp="254blq7da3e9o" />} data-id="element-23" data-mp="255d7b5rx7j5n" />

        {/* Services overview */}
        <Route path="/services" element={<Services data-id="element-26" data-mp="29wv7hrm4dfpk" />} data-id="element-25" data-mp="29vjvx5mfn3nw" />

        {/* Challenge landing pages */}
        <Route path="/services/new-to-leadership" element={<NewToLeadership data-id="element-28" data-mp="2euelqrithshi" />} data-id="element-27" data-mp="2ev6iw6s2by9w" />
        <Route path="/services/conflict-and-conversations" element={<ConflictAndConversations data-id="element-30" data-mp="2jsogx24jkt34" />} data-id="element-29" data-mp="2ex95egu0b99v" />
        <Route path="/services/meetings-and-facilitation" element={<MeetingsAndFacilitation data-id="element-32" data-mp="2nww9xbi18v75" />} data-id="element-31" data-mp="2jvuaatk7eh4n" />
        <Route path="/services/leading-in-complexity" element={<LeadingInComplexity data-id="element-34" data-mp="2stecc4pw4hgb" />} data-id="element-33" data-mp="2nts120tmhba5" />

        {/* How I work */}
        <Route path="/services/coaching" element={<Coaching data-id="element-36" data-mp="tivaaoens460" />} data-id="element-35" data-mp="thtpvtbr65bm" />
        <Route path="/services/embedded-partner" element={<EmbeddedPartner data-id="element-38" data-mp="yfv7saxfzyli" />} data-id="element-37" data-mp="tjobzayrg3ha" />

        {/* Format index pages */}
        <Route path="/services/courses" element={<Courses data-id="element-40" data-mp="21slrnuxfiurw" />} data-id="element-39" data-mp="21rkg7pci469n" />
        <Route path="/services/workshops" element={<Workshops data-id="element-42" data-mp="1wshcq9c6683s" />} data-id="element-41" data-mp="21s3xd3ubuqmm" />
        <Route path="/services/talks" element={<Talks data-id="element-44" data-mp="1wubwhkbpfu6a" />} data-id="element-43" data-mp="1wt97xj1uu3tj" />

        {/* Course detail pages */}
        <Route path="/services/courses/conflict-coaching" element={<ConflictCoaching data-id="element-46" data-mp="2apw3pii2mnxv" />} data-id="element-45" data-mp="2asilsc2l8luc" />
        <Route path="/services/courses/first-time-manager" element={<FirstTimeManager data-id="element-48" data-mp="25va40clcqjtm" />} data-id="element-47" data-mp="25snu46azns88" />
        <Route path="/services/courses/better-online-meetings" element={<BetterOnlineMeetings data-id="element-50" data-mp="2kobv7ml0fz7w" />} data-id="element-49" data-mp="2kq6j99rkw7g7" />
        <Route path="/services/courses/better-online-workshops" element={<BetterOnlineWorkshops data-id="element-52" data-mp="2fp92n1m7vlgt" />} data-id="element-51" data-mp="2frljtck5hrst" />
        <Route path="/services/courses/modern-product-management" element={<ModernProductManagement data-id="element-54" data-mp="2tkupp38w3v6l" />} data-id="element-53" data-mp="2tj9r92jgfs3g" />
        <Route path="/services/courses/art-of-facilitation" element={<ArtOfFacilitation data-id="element-56" data-mp="2pj9bnekmdaut" />} data-id="element-55" data-mp="2pgmy8yb1s14o" />

        {/* Open course sign-up pages */}
        <Route path="/events/betri-samskipti" element={<ConflictCourseSignup data-id="element-58" data-mp="2yi35ix6kfn4o" />} data-id="element-57" data-mp="33hfq1b9ysi43" />

        {/* Workshop detail pages */}
        <Route path="/services/workshops/strategy" element={<StrategyWorkshop data-id="element-60" data-mp="3i4o9ezdfftr5" />} data-id="element-59" data-mp="2yfqii5lyamkr" />
        <Route path="/services/workshops/feedback-culture" element={<FeedbackWorkshop data-id="element-62" data-mp="3n2zkfdfgkaay" />} data-id="element-61" data-mp="3i4efx1t6b4gp" />
        <Route path="/services/workshops/coaching-skills" element={<CoachingSkillsForManagers data-id="element-64" data-mp="385ypz25vu18s" />} data-id="element-63" data-mp="3n27o20e1e8jm" />

        {/* Legal */}
        <Route path="/privacy" element={<Privacy data-id="element-66" data-mp="3d40iset41exg" />} data-id="element-65" data-mp="387tbahl2fvde" />
        <Route path="/terms" element={<Terms data-id="element-68" data-mp="3d2p6trpih0v9" />} data-id="element-67" data-mp="3d3igp1jro6hm" />
        <Route path="/contact" element={<Contact data-id="element-70" data-mp="2zcvf91mmg2hu" />} data-id="element-69" data-mp="3d6cwgfru534p" />
      </Routes>
    </Suspense>;
}
export function App() {
  return <Router data-id="element-71" data-mp="344di5v87gd5g">
      <LanguageProvider data-id="element-72" data-mp="344x03bxuv1jh">
        <Layout data-id="element-73" data-mp="345ernv9korl2">
          <AnimatedRoutes data-id="element-74" data-mp="345ycpkuirw3b" />
        </Layout>
      </LanguageProvider>
    </Router>;
}